import React from "react";

const ProductBg = ({ color, height, width }) => {
  const topClassname = `prod-bg prod-bg-top bg-${color}`;
  const botCornerClassname = `prod-bg prod-bg-botcorner bg-${color}`;
  const leftClassname = `prod-bg prod-bg-left bg-${color}`;
  const bottomClassname = `prod-bg prod-bg-bottom bg-${color}`;

  return (
    <div className="prod-bg__container absolute" style={{ height, width }}>
      <div className={topClassname}></div>
      <div className={botCornerClassname}></div>
      <div className={leftClassname}></div>
      <div className={bottomClassname}></div>
    </div>
  );
};

export default ProductBg;
